var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "migration migration--verify" },
    [
      !_vm.error && !_vm.login && !_vm.resetPassword && !_vm.isLoggedIn
        ? [
            _c("h1", {
              domProps: { innerHTML: _vm._s(_vm.$t("migration.verify.title")) },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "migration__text",
              domProps: { innerHTML: _vm._s(_vm.$t("migration.verify.text")) },
            }),
            _vm._v(" "),
            _vm.response.message
              ? _c("GeneralMessage", {
                  attrs: {
                    message: _vm.response.message,
                    type: _vm.response.type,
                  },
                  on: {
                    close: function ($event) {
                      _vm.response.message = ""
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("ValidationObserver", {
              ref: "form",
              attrs: { tag: "form", novalidate: "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (ref) {
                      var invalid = ref.invalid
                      var errors = ref.errors
                      return [
                        _c("ValidationProvider", {
                          attrs: {
                            name: "code",
                            rules: "required",
                            tag: "div",
                            customMessages: {
                              required: _vm.$t("forms.errors.fieldEmpty"),
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  var invalid = ref.invalid
                                  var validated = ref.validated
                                  return [
                                    _c("FormInput", {
                                      attrs: {
                                        type: "text",
                                        placeholder: _vm.$t(
                                          "migration.verify.codeLabel"
                                        ),
                                        label: _vm.$t(
                                          "migration.verify.codeLabel"
                                        ),
                                        error: errors.length > 0,
                                        "error-message": errors[0],
                                        disabled: _vm.disabled,
                                        required: "",
                                      },
                                      model: {
                                        value: _vm.form.token,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "token", $$v)
                                        },
                                        expression: "form.token",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "migration__text" }, [
                          _c(
                            "p",
                            [
                              _c("Button", {
                                attrs: {
                                  level: "tertiary",
                                  type: "button",
                                  text: _vm.$t("migration.verify.resendButton"),
                                  disabled: _vm.disabled,
                                  arrow: "",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.onResend.apply(null, arguments)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("Button", {
                          attrs: {
                            type: "submit",
                            level: "primary",
                            text: _vm.$t("migration.verify.sendButton"),
                            disabled: _vm.disabled,
                          },
                        }),
                      ]
                    },
                  },
                ],
                null,
                false,
                1309498457
              ),
            }),
          ]
        : !_vm.error && _vm.isLoggedIn
        ? [
            _c("h1", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("migration.verify.loggedInTitle")),
              },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "migration__text",
              domProps: {
                innerHTML: _vm._s(_vm.$t("migration.verify.loggedInText")),
              },
            }),
            _vm._v(" "),
            _c("Button", {
              attrs: {
                level: "primary",
                type: "button",
                text: _vm.$t("migration.verify.loggedInButton"),
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.goToAccount.apply(null, arguments)
                },
              },
            }),
          ]
        : !_vm.error && _vm.login
        ? [
            _c("h1", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("migration.verify.loginTitle")),
              },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "migration__text",
              domProps: {
                innerHTML: _vm._s(_vm.$t("migration.verify.loginText")),
              },
            }),
            _vm._v(" "),
            _c("FormLogin", { on: { loading: _vm.setLoading } }),
          ]
        : !_vm.error && _vm.resetPassword
        ? [
            _c("h1", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("migration.verify.resetTitle")),
              },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "migration__text",
              domProps: {
                innerHTML: _vm._s(_vm.$t("migration.verify.resetText")),
              },
            }),
            _vm._v(" "),
            _c("FormPasswordReset", {
              attrs: { token: _vm.resetPasswordToken },
              on: { loading: _vm.setLoading, resetted: _vm.onReset },
            }),
          ]
        : [
            _c("h1", {
              domProps: { innerHTML: _vm._s(_vm.$t("migration.errorTitle")) },
            }),
            _vm._v(" "),
            _c("GeneralMessage", {
              attrs: { message: _vm.error, type: "error", stick: "" },
            }),
            _vm._v(" "),
            _c("Button", {
              attrs: {
                level: "primary",
                type: "button",
                text: _vm.$t("migration.cancelButton"),
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onCancel.apply(null, arguments)
                },
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }